module.exports = __webpack_public_path__ + "img/business_event_aus.337f3faa.png";